module.exports = __webpack_public_path__ + "e0eef8f8438e7b97a300d8cfcee773e3.png";